angular.module('picmonicng').directive('audioPlayer', [
  '$filter',
  '$interval',
  'LearnService',
  'UserService',
  '$rootScope',
  'ngBowser',
  '$cookies',
  'XpService',
  function ($filter, $interval, LearnService, UserService, $rootScope, ngBowser, $cookies, XpService) {
    return {
      template: '<audio></audio>',
      replace: true,
      restrict: 'E',
      link: function (scope, element, attrs) {
        if (!LearnService.currentCard.$promise) {
          return;
        }
        LearnService.audioMode = 'educational'; //Defaults to educational now that the setting has been removed
        LearnService.setAudioSrc(element[0]);
        LearnService.asyncAudioDownload();

        if (LearnService.audioElement) {
          LearnService.audioElement.muted = LearnService.audioMuted;
        }

        element.bind('canplay', function () {
          scope.$apply(function () {
            $rootScope.$broadcast('audioReady');
          });
        });

        element.bind('loadeddata', function () {
          scope.$apply(function () {
            $rootScope.$broadcast('audioLoaded');
          });
        });

        element.bind('ended', function () {
          scope.$apply(function () {
            if (LearnService.education_completed_flag) {
              XpService.grant(
                'EducationalAudioLearned',
                LearnService.currentCard.card_id,
                angular.element('.audio-time-text')
              );

              setTimeout(function () {
                $rootScope.$broadcast('cardDataChanged', {
                  action: 'learn_attempt',
                  card_id: LearnService.currentCard.card_id,
                });
              }, 1000);
            }
          });
        });

        //fix for weird chrome bug that can cause audio playback to crash when seeked to very specific times on certain audios
        element.bind('error', function (e) {
          var time = LearnService.currentTime + 0.01;
          element.load();
          element[0].currentTime = time;
          scope.$apply(function () {
            element[0].currentTime = time;
          });
          atlasEvent('error', 'pipeline decode error');
        });

        element.bind('timeupdate', function () {
          scope.$apply(function () {
            LearnService.currentTime = LearnService.audioElement.currentTime;
            if (LearnService.endTime != 0 && LearnService.audioElement.currentTime >= LearnService.endTime - 0.5) {
              if (LearnService.audioElement) {
                LearnService.audioElement.pause();
              }
              LearnService.endTime = 0;
            }

            // Mark as 'Listened' if user has listened to >= 50% of audio time
            if (
              LearnService.audioElement &&
              LearnService.currentTime / LearnService.audioElement.duration >= 0.5 &&
              LearnService.mode == 'learn' &&
              !LearnService.audioElement.paused
            ) {
              if (LearnService.audioMode == 'educational') {
                LearnService.education_completed_flag = 1;
              } else if (LearnService.audioMode == 'story') {
                LearnService.story_completed_flag = 1;
              }
            }

            if (
              LearnService.audioElement &&
              LearnService.currentTime > LearnService.audioElement.duration - 0.5 &&
              !LearnService.audioElement.paused
            ) {
              if (LearnService.shouldShowPostBar()) {
                LearnService.showPostBar = true;
                LearnService.visiblePostBar = true;
              }
            }
          });
        });

        function setAudioSpeed() {
          if (LearnService.audioElement) {
            if (UserService.user.audio_speed > 0) {
              LearnService.audioElement.playbackRate = UserService.user.audio_speed;
            } else {
              LearnService.audioElement.playbackRate = 1;
            }
          }
        }

        function setVolume() {
          if (ngBowser.isDesktop()) {
            LearnService.setVolume(UserService.user.audio_volume);
          }
        }

        element.bind('loadstart', function () {
          scope.$apply(function () {
            setAudioSpeed();
            setVolume();
          });
        });

        element.bind('play', function () {
          scope.$apply(function () {
            setAudioSpeed();
            setVolume();
            LearnService.interval = $interval(LearnService.determineFact, 50);
            $rootScope.$broadcast('learnAudioPlay');
          });
        });

        element.bind('pause', function () {
          scope.$apply(function () {
            if (LearnService.interval) {
              $interval.cancel(LearnService.interval);
            }
            $rootScope.$broadcast('learnAudioPause');
          });
        });

        setAudioSpeed();
        setVolume();

        element.bind('ended', function () {
          scope.$apply(function () {
            if (LearnService.interval) {
              $interval.cancel(LearnService.interval);
            }

            if (LearnService.currentCard.primary_market_id != 108) {
              LearnService.clearSelectedFact();
            }

            if (
              !$filter('filter')(LearnService.currentFacts, {
                fact_stats: { viewed: 0 },
              }).length
            ) {
              LearnService.endStep(true);
            }
          });
        });

        scope.$on('$destroy', function () {
          if (LearnService.interval) {
            $interval.cancel(LearnService.interval);
          }
        });
      },
    };
  },
]);
